import { render, staticRenderFns } from "./otherCert.vue?vue&type=template&id=dccfd842"
import script from "./otherCert.vue?vue&type=script&lang=js"
export * from "./otherCert.vue?vue&type=script&lang=js"
import style0 from "./otherCert.vue?vue&type=style&index=0&id=dccfd842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports